/* eslint-disable linebreak-style */
/* eslint-disable react/require-default-props */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable object-curly-newline */
/* eslint-disable comma-dangle */
/* eslint react/prop-types: "off" */
/* eslint-disable max-len */
/* eslint-disable indent */
/* eslint-disable react/jsx-indent-props */
import React from "react";
import {
    AlertTriangle,
    CircleDot,
    LayoutGrid,
    ArrowUp,
    Ban,
    Hexagon, Diamond, RefreshCw,
    Target
} from 'lucide-react';

const challenges = [
    {
        id: 1,
        title: "Compliance pressure",
        description: "NABERS, Green Star and NCC requirements demand accurate, timely data most buildings can't produce.",
        icon: <AlertTriangle className="w-5 h-5 text-[#459ca5]" strokeWidth={1.5} />
    },
    {
        id: 2,
        title: "No visibility",
        description: "Fragmented systems leave operators guessing about where energy is going and why costs keep rising.",
        icon: <CircleDot className="w-5 h-5 text-[#459ca5]" strokeWidth={1.5} />
    },
    {
        id: 3,
        title: "Multi-site complexity",
        description: "Managing multiple sites means multiple systems, multiple logins, and no single source of truth.",
        icon: <LayoutGrid className="w-5 h-5 text-[#459ca5]" strokeWidth={1.5} />
    },
    {
        id: 4,
        title: "Rising costs",
        description: "Without insight into usage patterns, energy waste goes undetected and costs keep climbing.",
        icon: <ArrowUp className="w-5 h-5 text-[#459ca5]" strokeWidth={1.5} />
    },
    {
        id: 5,
        title: "Isolated systems",
        description: "BMS, HVAC, metering and lighting running in silos — no integration means no complete picture.",
        icon: <Ban className="w-5 h-5 text-[#459ca5]" strokeWidth={1.5} />
    },
    {
        id: 6,
        title: "Sustainability gaps",
        description: "ESG targets and net zero commitments require data most organisations simply don't have access to yet.",
        icon: <Target className="w-5 h-5 text-[#459ca5]" strokeWidth={1.5} />
    }
];

const pillars = [
    {
        id: 1,
        label: 'Pillar 01',
        title: 'Devices',
        description: 'Connected, intelligent meters designed for fast installation, interoperability, and reliable long-term performance.',
        icon: <Hexagon className="w-8 h-8 text-[#459ca5]" strokeWidth={1.5} />,
    },
    {
        id: 2,
        label: 'Pillar 02',
        title: 'Data',
        description: 'End-to-end software embedded on every device, consolidated through a central platform with 10+ year battery life.',
        icon: <Diamond className="w-8 h-8 text-[#459ca5]" strokeWidth={1.5} />,
    },
    {
        id: 3,
        label: 'Pillar 03',
        title: 'Decisions',
        description: 'AI-driven analytics that transform raw building data into actionable insights — detecting issues before they cost you.',
        icon: <RefreshCw className="w-8 h-8 text-[#459ca5]" strokeWidth={1.5} />,
    },
];

const ChallengeSection = () => {
    return (
        <section className="w-full py-20 lg:py-28 px-6">
            <div className="container max-w-[1440px] mx-auto px-6 mx-auto lg:max-w-screen-xl">
                <div className="max-w-5xl mb-16">
                    <span className="text-theme-teal font-bold text-sm tracking-[0.2em] uppercase ">
                        The Challenge
                    </span>
                    <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 tracking-tight text-black dark:text-white">
                        Energy management is becoming critical infrastructure.
                    </h2>
                    <p className="mt-5 text-base lg:text-xl text-gray-400 font-light leading-relaxed">
                        Compliance requirements are intensifying. Energy costs are climbing. Most buildings still lack the visibility to act on either.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ">
                    {challenges.map((card) => (
                        <div
                            key={card.id}
                            className="bg-white rounded-xl p-8 border border-gray-00 shadow-sm border-l-[4px] border-l-theme-teal hover:shadow-md transition-shadow duration-300 flex flex-col dark:bg-theme-tarjet/70 dark:border-theme-border dark:border-l-theme-teal"
                        >
                            <div className="mb-5">
                                {card.icon}
                            </div>
                            {(card.title) && (
                                <h3 className="text-xl font-bold text-gray-900 mb-3 text-black text-base lg:text-lg dark:text-theme-teal">
                                    {card.title}
                                </h3>
                            )}

                            {(card.description) && (
                                <p className="text-gray-400  leading-relaxed font-light">
                                    {card.description}
                                </p>
                            )}
                        </div>
                    ))}
                </div>

                <div className="max-w-5xl mt-20 lg:mt-32">
                    <span className="text-theme-teal font-bold text-sm tracking-[0.2em] uppercase ">
                        THE NUBE IO FRAMEWORK
                    </span>
                    <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 tracking-tight text-black dark:text-white">
                        How we solve it.
                    </h2>
                    <p className="mt-5 text-base lg:text-xl text-gray-400 font-light leading-relaxed">
                        Three interconnected pillars that take you from raw data to real decisions — without the complexity of a traditional BMS.
                    </p>
                </div>

                <div className="mt-20 rounded-xl border border-gray-200 shadow-sm flex flex-col md:flex-row md:divide-x divide-y md:divide-y-0 divide-gray-200 overflow-hidden ">
                    {pillars.map((pillar) => (
                        <div
                            key={pillar.id}
                            className="bg-white flex-1 p-10 lg:p-14 flex flex-col items-center text-center dark:bg-theme-tarjet/90 dark:border-theme-border "
                        >
                            <span className="text-theme-teal font-bold text-xs tracking-[0.2em] uppercase mb-6 dark:text-white ">
                                {pillar.label}
                            </span>

                            <div className="mb-5">
                                {pillar.icon}
                            </div>

                            {(pillar.title) && (
                                <h3 className="text-xl font-bold text-gray-900 mb-3 text-black text-base lg:text-lg dark:text-theme-teal">
                                    {pillar.title}
                                </h3>
                            )}

                            {(pillar.description) && (
                                <p className="text-gray-400 leading-relaxed font-light max-w-sm">
                                    {pillar.description}
                                </p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ChallengeSection;
